var _defs, _path, _use, _mask, _g, _g2, _path2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 43,
    viewBox: "0 0 25 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M8.977 38.987c-.14.002-.288.003-.434.003-3.31 0-5.558-.662-6.87-2.024-.91-.944-1.34-2.231-1.28-3.825.014-.38.013-.61.013-.82-.002-.368-.004-.685.079-1.61.208-2.327.262-4.563.263-4.585-.113-1.563-.28-14.801-.286-15.364l.29-5.87.044-.067C2.047 2.928 3.4 2.044 4.094 1.685c.134-.068.237-.114.303-.141C5.207.6 8.503.479 8.931.467l.062-.002c.639.021 3.789.168 4.575 1.078.393.163 2.072.963 3.601 3.282l.044.067.29 5.852c-.007.58-.173 13.819-.287 15.41.002 0 .056 2.233.265 4.558.082.924.08 1.242.079 1.61-.001.21-.003.44.011.819.061 1.594-.37 2.881-1.279 3.825-1.311 1.362-3.559 2.024-6.869 2.024-.146 0-.295 0-.446-.003z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "49.265%",
    x2: "49.296%",
    y1: "37.801%",
    y2: "63.545%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7E8083"
  })), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M.2 24.065c1.798-5.217 2.315-5.845 2.527-7.91.223-2.183.73-7.355.861-8.736.133-1.396.337-4.541.818-6.026C4.5 1.104 4.734.18 4.734.18L4.43 1.976s-.968 5.832-.64 8.617c.332 2.826-.324 7.758-.976 10.338C2.18 23.436.199 24.065.199 24.065z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "49.805%",
    x2: "49.329%",
    y1: "80.528%",
    y2: "67.954%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#C6C7DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DEDFEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: "50%",
    x2: "50%",
    y1: "87.275%",
    y2: "20.055%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4D53D5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M1.595 16.657c.07.123.468.616.483.298.048-.975.039-2.374 0-3.717-.04-1.382 0-8.614 0-8.614S1.245 2.2.302.06c0 0-.815 12.872 1.293 16.596"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: "50%",
    x2: "50%",
    y1: "98.475%",
    y2: "20.288%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2D3842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#303030"
  })), /*#__PURE__*/React.createElement("path", {
    id: "j",
    d: "M4.814.367c-1.287 0-3.521.003-3.65.017l-.018.001C.522.413.307 1.037.15 1.548c-.448 1.453.762 5.408.762 5.408C.805 5.97.5 3.681.53 3.496c.096.034 2.267.827 4.43.827s4.1-.793 4.198-.827c.03.185-.276 2.473-.382 3.46 0 0 1.21-3.955.762-5.408C9.38 1.038 9.165.413 8.54.385h-.017C8.394.37 6.16.367 4.874.366h-.06z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: "50%",
    x2: "50%",
    y1: "98.475%",
    y2: "20.288%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2D3842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#303030"
  })), /*#__PURE__*/React.createElement("path", {
    id: "m",
    d: "M.065 5.012s.04 7.233 0 8.615c-.039 1.342-.048 2.741 0 3.716.015.318.413-.174.483-.298C2.656 13.321 1.904.035 1.904.035 1.041 2.227.064 5.011.064 5.011"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: "50%",
    x2: "50%",
    y1: "98.475%",
    y2: "20.288%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2D3842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#303030"
  })), /*#__PURE__*/React.createElement("path", {
    id: "p",
    d: "M.6 2.563c-.395.302-.566.8-.435 1.27l1.763 3.865c.159.57.719 1.004 1.326.949h6.822c.607.055 1.167-.38 1.326-.95l1.763-3.864c.13-.47-.041-.968-.435-1.27C10.03.501 8.54.014 6.664.014 4.788.014 3.298.501.6 2.564"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: "50%",
    x2: "50%",
    y1: "98.475%",
    y2: "20.288%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2D3842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#303030"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M13.034 41.697c-.145 0-.294-.001-.445-.004-.14.003-.288.004-.434.004-3.31 0-5.558-.662-6.87-2.025-.91-.944-1.34-2.23-1.28-3.825.015-.379.013-.61.013-.819-.002-.368-.004-.686.079-1.61.208-2.327.262-4.563.263-4.586-.113-1.563-.28-14.8-.286-15.363l.29-5.87.044-.067C5.66 5.634 7.012 4.75 7.706 4.392c.134-.068.237-.114.303-.142.81-.943 4.106-1.065 4.534-1.076l.009-.003.053.001c.639.021 3.789.168 4.575 1.078.393.163 2.072.962 3.601 3.282l.044.066.29 5.853c-.007.58-.173 13.818-.287 15.409.002 0 .056 2.234.265 4.558.082.925.08 1.243.079 1.611-.001.21-.003.44.011.818.061 1.595-.37 2.882-1.279 3.826-1.311 1.362-3.559 2.024-6.869 2.024z",
    opacity: 0.264
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#FEFEFE",
    transform: "translate(2 1.17)",
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.427 15.54)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#E0E2F7",
    d: "M.2 24.065s1.98-.629 2.614-3.134c.652-2.58 1.308-7.512.976-10.338-.328-2.785.64-8.617.64-8.617L4.734.18s-.234.924-.328 1.213c-.48 1.485-.685 4.63-.818 6.026-.131 1.381-.638 6.553-.861 8.736-.212 2.065-.729 2.693-2.528 7.91",
    mask: "url(#d)",
    style: {
      mixBlendMode: "overlay"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.389
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7F82C5",
    d: "M4.921 36.847c-.556-2.27-1.372-4.953-1.112-9.481.245-4.288-.402-8.822-.9-11.53.06 4.203.16 10.53.234 11.584 0 0-.244 1.897-.366 4.267-.07 1.369-.111 1.414-.106 2.483.01 2.58.91 4.739 4.668 5.43-1.396-.955-2.202-1.872-2.418-2.753z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M5.576 24.065s-1.88-.657-2.615-3.134c-.76-2.561-1.25-7.502-1.005-10.338.24-2.792-.263-6.42-.629-8.642-.07-.423-.315-1.77-.315-1.77s.252 1.47.315 1.77c.353 1.7.864 4.145.864 5.532 0 1.387.52 6.518.858 8.672.32 2.05.245 1.03 2.527 7.91",
    transform: "translate(1.777 15.54)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#EC1D24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.51 38.312c-.894-.676-1.27-1.688-1.795-2.427-.236-.331-.755-.127-.713.278.313 3.049 4.46 3.456 4.46 3.456-1.15-.682-1.8-1.117-1.953-1.307zM14.597 39.605c.424-.212 1.233-.596 1.686-1.182.82-.811 1.604-1.772 2.1-2.41.208-.267.643-.11.627.229-.135 2.876-4.413 3.363-4.413 3.363"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M13.208 8.553s-.41-3.14-.673-4.16a19.491 19.491 0 0 0-.548-1.734 33.07 33.07 0 0 0-.6-1.292l-.375-.14c-.796-.99-4.36-.995-4.36-.995-3.884.197-4.22.904-4.22.904l-.484.231-.57 1.34S.834 4.083.726 4.563c-.222.979-.433 3.99-.433 3.99l.044 1.964 12.842-.43.028-1.535z",
    opacity: 0.221,
    transform: "translate(4.33 1.948)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#AAACDA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.382 12.036S4.086 7.803 6.28 3.314c0 0-1.627 2.991-1.655 8.32l-.242.402zM17.87 11.934s.164-4.184-2.169-8.62c0 0 1.72 2.957 1.916 8.223l.254.397z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.942 13.21)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "i",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M1.595 16.657c.07.123.468.616.483.298.048-.975.039-2.374 0-3.717-.04-1.382 0-8.614 0-8.614S1.245 2.2.302.06c0 0-.815 12.872 1.293 16.596",
    mask: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#23253E",
    d: "M.302.061s-.815 12.872 1.293 16.596c.054.094.298.403.417.403.037 0 .062-.03.066-.105.047-.975.038-2.374 0-3.716-.04-1.383 0-8.615 0-8.615S1.245 2.2.302.06m.307 1.74a74.3 74.3 0 0 1 1.08 2.887c-.004.776-.037 7.243 0 8.561.03 1.046.04 2 .029 2.778C.368 12.9.48 5.237.609 1.801",
    mask: "url(#i)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.272 29.909)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M4.814.367c-1.287 0-3.521.003-3.65.017l-.018.001C.522.413.307 1.037.15 1.548c-.448 1.453.762 5.408.762 5.408C.805 5.97.5 3.681.53 3.496c.096.034 2.267.827 4.43.827s4.1-.793 4.198-.827c.03.185-.276 2.473-.382 3.46 0 0 1.21-3.955.762-5.408C9.38 1.038 9.165.413 8.54.385h-.017C8.394.37 6.16.367 4.874.366h-.06z",
    mask: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#23253E",
    d: "M4.874.367h-.06c-1.287 0-3.521.003-3.651.017l-.017.001C.522.413.307 1.037.15 1.548-.298 3 .91 6.956.91 6.956.805 5.97.498 3.681.53 3.496c.098.035 2.268.827 4.431.827 2.163 0 4.1-.792 4.197-.827.032.185-.275 2.473-.38 3.46 0 0 1.209-3.955.76-5.408-.157-.51-.372-1.135-.996-1.163h-.017C8.394.37 6.16.367 4.874.366M1.146.385l.051.386c.077-.005.647-.014 3.617-.016h.06c2.969.002 3.54.01 3.609.015l.028.002h.012c.315.015.469.324.644.89.101.33.103.833.046 1.403l-.184.065-.045.017c-.618.237-2.248.788-4.024.788-1.945 0-3.914-.667-4.302-.805l-.184-.065C.417 2.495.42 1.992.521 1.662c.174-.566.328-.875.643-.89L1.146.386",
    mask: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E5E5E",
    d: "M.439 2.453s4.033 1.5 8.81 0v-.125s-4.224 1.532-8.81 0v.125z",
    mask: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E5E5E",
    d: "M.439 1.676s4.033 1.5 8.81 0v-.124s-4.224 1.531-8.81 0v.124z",
    mask: "url(#l)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.98 12.821)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "o",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M.065 5.012s.04 7.233 0 8.615c-.039 1.342-.048 2.741 0 3.716.015.318.413-.174.483-.298C2.656 13.321 1.904.035 1.904.035 1.041 2.227.064 5.011.064 5.011",
    mask: "url(#o)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#23253E",
    d: "M1.904.035C1.042 2.228.064 5.012.064 5.012s.04 7.233 0 8.615c-.038 1.342-.047 2.742 0 3.716.004.076.03.105.067.105.12 0 .363-.309.417-.403C2.656 13.321 1.904.035 1.904.035m-.312 1.904c.11 3.596.173 11.359-1.167 14.476-.011-.778-.002-1.73.028-2.777.037-1.317.004-7.78 0-8.56.108-.305.589-1.665 1.14-3.139",
    mask: "url(#o)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.4 8.938)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "r",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#p"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M.6 2.563c-.395.302-.566.8-.435 1.27l1.763 3.865c.159.57.719 1.004 1.326.949h6.822c.607.055 1.167-.38 1.326-.95l1.763-3.864c.13-.47-.041-.968-.435-1.27C10.03.501 8.54.014 6.664.014 4.788.014 3.298.501.6 2.564",
    mask: "url(#r)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#23253E",
    d: "M6.665.014C4.789.014 3.298.501.6 2.564c-.394.3-.566.8-.435 1.27l1.763 3.864c.15.537.656.953 1.221.953.035 0 .07-.002.105-.004h6.822c.035.002.07.004.104.004.566 0 1.072-.416 1.222-.953l1.763-3.865c.13-.469-.041-.968-.435-1.27C10.032.501 8.54.014 6.665.014m0 .388c1.685 0 3.113.394 5.829 2.47.261.2.378.523.304.83l-1.75 3.835-.012.027-.009.03c-.106.381-.47.669-.847.669-.022 0-.045-.001-.069-.004H3.22a.691.691 0 0 1-.07.004c-.376 0-.74-.288-.847-.67l-.008-.029-.013-.027L.532 3.703a.806.806 0 0 1 .304-.831C3.552.796 4.98.402 6.665.402",
    mask: "url(#r)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FED200",
    d: "M6.079 3.195s-.924.369-2.308 1.974c-.621.72-.377 1.73-.377 1.73S4.95 5.636 5.483 4.587c.174-.343.48-.876.48-.876l.265-.594-.149.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F89D32",
    d: "M3.394 6.9s2.548-3.215 2.455-3.585l.379-.2S5.682 5.093 3.394 6.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDEB9D",
    d: "M4.253 5.787s-.155-.333.199-.9c.354-.568 1.246-1.175 1.246-1.175S4.643 5.407 4.253 5.787"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FED200",
    d: "M16.027 3.313s.924.368 2.308 1.974c.621.72.377 1.73.377 1.73s-1.556-1.265-2.09-2.314c-.174-.343-.48-.876-.48-.876l-.264-.594.149.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F89D32",
    d: "M18.712 7.017s-2.548-3.215-2.456-3.586l-.378-.198s.546 1.976 2.834 3.784"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDEB9D",
    d: "M17.853 5.904s.155-.333-.2-.9c-.352-.568-1.245-1.175-1.245-1.175s1.055 1.694 1.445 2.075"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M10.992 1.345h-.009c-.924.027-3.834.187-4.756 1.125-.069.031-.158.073-.266.128-.72.37-2.12 1.284-3.408 3.238l-.088.133-.008.159-.285 5.773-.002.018v.017c.008.56.172 13.656.286 15.38a79.96 79.96 0 0 1-.261 4.54c-.084.938-.082 1.262-.08 1.638 0 .213.001.434-.013.806-.063 1.677.395 3.036 1.36 4.039 1.371 1.422 3.687 2.114 7.08 2.114.145 0 .291-.002.44-.004.15.002.296.004.44.004 3.395 0 5.71-.692 7.08-2.114.966-1.003 1.424-2.362 1.36-4.039-.013-.372-.012-.592-.011-.806.002-.376.003-.7-.08-1.638a79.697 79.697 0 0 1-.262-4.54c.115-1.722.279-14.82.286-15.38v-.017l-.001-.018-.286-5.773-.008-.159-.087-.133c-1.501-2.275-3.162-3.14-3.674-3.365-.923-.939-3.831-1.099-4.739-1.126h-.008zm-.009.583c.023 0 3.782.117 4.404 1.028 0 0 1.863.66 3.54 3.201l.285 5.772s-.171 13.774-.286 15.374c0 0 .052 2.24.264 4.606.129 1.434.051 1.36.091 2.413.12 3.203-1.75 5.548-7.859 5.548-.144 0-.29-.001-.44-.004-.149.003-.295.004-.44.004-6.106 0-7.978-2.345-7.858-5.548.04-1.053-.037-.979.091-2.413.212-2.365.264-4.606.264-4.606-.114-1.6-.286-15.374-.286-15.374l.286-5.772C4.273 4.284 5.61 3.434 6.228 3.116c.22-.114.35-.16.35-.16.622-.911 4.382-1.028 4.404-1.028h.001z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.6f477e09e15404dc54a68935952cd422.svg";
export { ForwardRef as ReactComponent };